/* istanbul ignore file -- @preserve */
import React from 'react';

import SurveyFormComponent from './components/survey';

function App() {
    return (
        <>
            <SurveyFormComponent />
        </>
    );
}

export default App;
